import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'containsstring'
})
export class ContainsStringPipe implements PipeTransform {

    transform(value: any, contains: string): boolean {
        return value !== null && value !== undefined && (typeof value === "string" && new String(value).toLowerCase().includes(contains));
    }
}